export const PFSStyle = {

    variants: {
      wrapper: {
        '.pfsWrapper': {
          minWidth: '100%',
        },
        '.alignment': {
          display: 'flex',
          justifyContent: 'center',
          minWidth: '100%',
        },
        '.grid': {
          minWidth: '100%',
        },
        '.nav': {
          minWidth: '100%',
          display: 'flex',
          justifyContent: 'center',
          background:'yellow',
        },
        '.pfsNav': {
          minWidth: '100%',
          width: '100%',
        },
        '.skipLinkWrapper': {
          paddingTop: '24px',
        },
      },
    },
  };

